export default __webpack_public_path__ + "static/hotel-booking-e146678ddf169eb5716d7d1b8d52e84e.png";